import moment from "moment";
import {getGeneralStatus} from '../../utils/requestStatus'

export default () => [
  {
    title: 'Name',
    key: 'name',
    dataIndex: ['weekend.name'],
    sorter: true,
    render(txt: string, {weekend}: any) {
      return weekend.name
    }
  },
  {
    title: 'Date',
    key: 'from',
    dataIndex: 'from',
    sorter: true,
    defaultSortOrder: 'descend',
    sortDirections: ['descend', 'ascend', 'descend'],
    render(txt: any, {from, to}: any) {
      const mFrom = moment.utc(from);
      const mTo = moment.utc(to);
      if (mTo.diff(mFrom, 'days')) {
        return `${mFrom.format('DD/MM/YYYY')} - ${mTo.format('DD/MM/YYYY')}`
      }
      return mFrom.format('DD/MM/YYYY')
    }
  },
  {
    title: 'Status',
    key: 'status',
    render(record: any) {
      return getGeneralStatus(record)
    }
  }
];